enum SearchExportTypes {
  FetchExportsRequest = 'searchexports.FetchExports.Request',
  FetchExportsSuccess = 'searchexports.FetchExports.Success',
  FetchExportsFailure = 'searchexports.FetchExports.Failure',
  GetProgressRequest = 'searchexports.GetProgress.Request',
  GetProgressSuccess = 'searchexports.GetProgress.Success',
  GetProgressFailure = 'searchexports.GetProgress.Failure',
  CancelExportRequest = 'searchexports.CancelExport.Request',
  CancelExportSuccess = 'searchexports.CancelExport.Success',
  CancelExportFailure = 'searchexports.CancelExport.Failure',
  CreateExportRequest = 'searchexports.CreateExport.Request',
  CreateExportSuccess = 'searchexports.CreateExport.Success',
  CreateExportFailure = 'searchexports.CreateExport.Failure',
  CreateUserCSVRequest = 'searchexports.CreateUserCSV.Request',
  CreateUserCSVSuccess = 'searchexports.CreateUserCSV.Success',
  CreateUserCSVFailure = 'searchexports.CreateUserCSV.Failure',
}

export { SearchExportTypes };
